import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { faChevronLeft, faChevronRight, faLanguage } from "@fortawesome/free-solid-svg-icons";

import { setLanguageId, setUiLanguageId } from '../../../redux/actions/baseActions';

import "./HeaderInvoive.scss";

function useOutsideAlerter(ref, action) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        action();
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

function Separator({ color = "white", height = 1 }) {
  return (
    <hr
      className="separator-line"
      style={{
        backgroundColor: color,
        height: height,
        border: "none",
      }}
    />
  );
}

const HeaderInvoive = ({ t, setLanguageId, setUiLanguageId, branchInfo, currentLanguageId }) => {
  const location = useLocation();
  const history = useHistory();
  const wrapperRef = useRef(null);
  const { branchId, orderId } = useParams();
  const [menuOpened, setMenuOpened] = useState(false);
  const [hebLanguage, setHebLanguage] = useState(true);

  useOutsideAlerter(wrapperRef, function () {
    const checkbox = document.getElementById("close-mobile-menu");
    if (checkbox.value === "true") {
      checkbox.click();
    }
  });

  useEffect(() => {
    setUiLanguageId(hebLanguage ? 2 : 1);
    setLanguageId(hebLanguage ? 2 : 1);
  }, [hebLanguage]);

  const onBarsClick = () => {
    if (location.pathname === `/${branchId}/invoice/${orderId}`) {
      return;
    }
    history.goBack();
  };

  const changeLanguageId = () => {

    setHebLanguage(!hebLanguage);    
  };

  const goToPrivacy = () => {
    window.open('https://www.ipos.co.il/privacy-terms-service', '_blank');
  };

  return (
    <header className="base-header-invoice">
      <div
        className={`header-invoice ${menuOpened ? "opened" : "closed"}`}
        ref={wrapperRef}
      >
        <input
          type="checkbox"
          id={"close-mobile-menu"}
          className={"hidden-menu-checkbox"}
          value={menuOpened}
          onClick={() => {
            setMenuOpened(!menuOpened);
          }}
        />

        <span className="icon-bar" key={1} />
        <span className="icon-bar" key={2} />
        <span className="icon-bar" key={3} />

        <div id="menu">
          <div className={"menu-content"}>
            <div className="branch-info restart-order">
              <div className="branch-info restart-order">
                <button
                  className={"btn btn-primary btn-restart-order"}
                  onClick={goToPrivacy}
                >
                  <FontAwesomeIcon icon="newspaper" />
                  {t("buttons.privacy")}
                </button>
              </div>
            </div>
            <Separator />
            <div className="branch-info restart-order">
              <div className="branch-info restart-order">
                <button
                  className={"btn btn-primary btn-restart-order"}
                  onClick={goToPrivacy}
                >
                  <FontAwesomeIcon icon="newspaper" />
                  {t("buttons.terms")}
                </button>
              </div>
            </div>
            <Separator />
            <div className="branch-info restart-order version">
              {"Ver: 1.3.37"}
            </div>
          </div>
          <Separator />
        </div>
      </div>

      <div className={"branch-name"}> {branchInfo.PlaseName} </div>

      
        { location.pathname !== `/${branchId}/invoice/${orderId}` &&
          location.pathname !==
            `/${branchId}/invoice/${orderId}/success-payment` && (            
              <div className={"back"} onClick={onBarsClick}>
                { currentLanguageId === 1 && (
                  <FontAwesomeIcon icon={faChevronRight} style={{ color: 'white' }} />)
                }
                { currentLanguageId === 2 && (
                  <FontAwesomeIcon icon={faChevronLeft} style={{ color: 'white' }} />)
                }
              </div>
        )}
        { location.pathname === `/${branchId}/invoice/${orderId}` && (
          <div className={"language"}  onClick={(e) => changeLanguageId()}>
            <FontAwesomeIcon icon={faLanguage} style={{ color: 'white' }}/>            
          </div>
        )}
    </header>
  );
};

const mapStateToProps = (state) => {
  const { 
    branchInfo, 
    currentLanguageId 
  } = state;

  return {
    branchInfo,
    currentLanguageId,
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setLanguageId,
      setUiLanguageId
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(HeaderInvoive);
